import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { context } from 'src/app/shared/enums/context.enum';

@Injectable({
  providedIn: 'root',
})
export class ContextResolverService implements Resolve<void> {
  context$: BehaviorSubject<string> = new BehaviorSubject(
    context.PUBLIC_SITE.toString()
  );

  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot
  ): void | Promise<void> | Observable<void> {
    this.setContext(route.url[0].path || context.PUBLIC_SITE);
  }

  setContext(context: string): void {
    this.context$.next(context);
  }

  getContext(): BehaviorSubject<string> {
    return this.context$;
  }
}
